module.exports = __webpack_public_path__ + "static/lender-456de160e1aa80f76391a07213c90698.svg";